import React from 'react';
import { createUseStyles } from 'react-jss';

import MenuItem from '../../../MenuItem';


const useStyles = createUseStyles((theme) => ({
  label: {
    fontWeight: 500,
    textDecoration: 'underline',
    marginTop: theme.spacing(5),
  },
  logo: {
    width: 75,
  }
}));

const ProfileTitleExp = ({ result, label, data }) => {
  const classes = useStyles();

  return (
    <>     
      <li className={classes.label}>{label}</li>

      {data.exp_logo && (
        <MenuItem
          label="Logo :"
          customValue={<img alt="" src={'https://' + data.exp_logo} className={classes.logo} />}
          text={result?.us_exp_dic}
        />
      )}

      <MenuItem
        label="Name :"
        text={result?.us_exp_dic}
        customValue={data.exp_cie_name} 
      />
      {data.exp_title && (
        <MenuItem
          label="Title :"
          customValue={data.exp_title}
          text={result?.us_exp_dic}
        />
      )}
      {data.exp_website && (
        <MenuItem
          label="Website :"
          customValue={data.exp_website}
          text={result?.us_exp_dic}
        />
      )}
      {data.exp_area && (
        <MenuItem
          label="Area :"
          customValue={data.exp_area}
          text={result?.us_exp_dic}
        />
      )}
      
      {(data.exp_start || data.exp_end) && (
        <MenuItem
          label="Date :"
          customValue={data?.exp_start + ' to ' + data?.exp_end}
          text={result?.us_exp_dic}
        />
      )}
      {data.exp_detail && (
        <MenuItem
          label="Detail :"
          customValue={data.exp_detail}
          text={result?.us_exp_dic}
        />
      )}
    </>
  );
}

export default ProfileTitleExp;